import { useState } from 'react';

const faqs = [
  {
    q: 'Чи не зупинить впровадження поточний найм?',
    a: 'Ні. Запуск можна почати з одного регіону або категорії вакансій. Рекрутери продовжують працювати без паузи — HURMA поступово підключається до процесу.',
  },
  {
    q: 'Скільки часу займає впровадження?',
    a: 'Базові сценарії запускаються від 10 днів. Команда HURMA супроводжує запуск: воронки, ролі, доступи, міграція даних, інтеграції та навчання.',
  },
  {
    q: 'Чи інтегрується HURMA з ERP та іншими системами?',
    a: 'Так. HURMA підключається до 1С, SAP, Oracle та інших ERP через API. Дані передаються без ручного перенесення. Також підтримується інтеграція з LMS, телефонією та BI.',
  },
  {
    q: 'Як працювати з кандидатами без резюме?',
    a: 'Для лінійного найму достатньо простої заявки: ім\'я, телефон, місто, бажана позиція. HURMA фіксує кандидата й веде його по воронці без повного резюме.',
  },
  {
    q: 'Що робити, якщо рекрутерам складно переходити на нову систему?',
    a: 'HURMA показує рекрутеру конкретні дії: новий кандидат, статус, дзвінок, коментар, наступний крок. Під час запуску команда навчає користувачів і адаптує процес.',
  },
  {
    q: 'Чи замінює HURMA ERP?',
    a: 'Ні. ERP залишається головною системою обліку. HURMA керує HR-шляхом кандидата й передає дані в ERP через інтеграцію.',
  },
  {
    q: 'Чи допоможе система, якщо кандидатів мало?',
    a: 'HURMA не створює кандидатів, але допомагає не втрачати тих, хто вже відгукнувся. AI-інструменти переглядають стару базу й знаходять підходящих на поточні вакансії.',
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="py-24 lg:py-32 bg-white">
      <div className="max-w-[800px] mx-auto px-6 lg:px-10">

        <div className="text-center mb-14 lg:mb-20">
          <h2 className="font-heading font-bold text-[#1d1d1f] leading-[1.08] tracking-tight" style={{ fontSize: 'clamp(2rem, 4.5vw, 3.5rem)' }}>
            Поширені питання
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#f5f5f7] rounded-[24px] overflow-hidden transition-colors"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer group"
              >
                <span
                  className="font-heading font-medium text-base lg:text-lg leading-snug transition-colors"
                  style={{ color: open === i ? '#F96B25' : '#1d1d1f' }}
                >
                  {faq.q}
                </span>
                <i
                  className={`ri-add-line text-sm flex-shrink-0 transition-all duration-200 ${open === i ? 'rotate-45 text-[#F96B25]' : 'text-gray-400'}`}
                ></i>
              </button>
              {open === i && (
                <div className="px-6 pb-5">
                  <div className="w-full h-px bg-gray-200 mb-4"></div>
                  <p className="text-gray-500 text-base leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}